class Conexao{

static api = 'http://servidor.geocontrole.com/ApiReact/'
 //  static api = 'http://34.138.14.62/ApiReact/'
}

export default Conexao


